/** Keep salon services/treatments out of the AM/PM product routine UI. */
export function isRoutineCatalogProduct(item) {
  if (!item || typeof item !== 'object') return false;
  const id = String(item.product_id || item.id || '').trim();
  if (id.startsWith('fps_')) return false;
  if (item.treatment_id != null || item.hq_treatment_id) return false;
  const st = String(item.service_type || '').trim().toLowerCase();
  if (st && st !== 'other' && !item.sku && !item.product_domain) return false;
  const label = String(item.product_name || item.name || '').trim();
  if (!label) return false;
  if (item.treatment && !item.product_name && !item.sku) return false;
  return true;
}

export function filterRoutineProducts(list) {
  return (Array.isArray(list) ? list : []).filter(isRoutineCatalogProduct);
}
